import type { AnalyticsDestination } from "../analytics";

export const consoleDestination: AnalyticsDestination = {
  name: "console",
  push(event) {
    // oxlint-disable-next-line no-console
    console.log(
      `%c[analytics] ${event.event.name}`,
      "color: #6366f1; font-weight: bold; font-size: 12px",
      event,
    );
  },
};
